<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-12">
               <h1 class="pull-left">
                  <span style="color:#00a65a">{{com_TVOwnerName()}}</span> Recharge Reports
               </h1>
            </div>
         </div>
      </section>
      <section class="content">
         <form v-on:submit.prevent="searchReportData">
         <div class="row">
            <div class="col-xs-6 col-sm-2">
               <div class="form-group">
                  <filterDropdownOptions />
               </div>
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="From" type="text" value="" name="starttime" id="starttime" v-model="starttime" autocomplete="off" class="form-control input-sm datePicker">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <input placeholder="To" type="text" value="" name="stoptime" id="stoptime" v-model="stoptime" class="form-control input-sm datePicker" autocomplete="off">
            </div>
            <div class="col-xs-6 col-sm-2 form-group">
               <select title="" name="type" id="type" class="form-control input-sm select2" v-select="type" v-model="type" @change="searchReportData">
                  <option value="">Filter Type</option>
                  <option value="1">Received</option>
                  <option value="3">Return</option>
               </select>
            </div>
            <div id="btnSearch" class="col-xs-6 col-sm-2 pull-right form-group  btnLeft" style="margin-bottom: 5px">
               <button type="submit" class="btn btn-sm btn-submit pull-right">
                  <i class="fa fa-search"></i> Search
               </button>
            </div>
         </div>
         </form>
         <div class="row">
            <div class="col-md-12">
               <div class="box" id="pagination">
                  <div class="box-header">
                     <h3 class="box-title">
                        Total {{listArr.length}} Row Found
                     </h3>
                  </div>
                  <div class="box-body">
                     <div class="table-responsive">
                        <table class="table table-0024 table-bordered table-striped">
                           <thead>
                              <tr>
                                 <th class="tdCenter tdSN">SN</th>
                                 <th class="tdCenter">Reseller Name</th>
                                 <th class="tdCenter">Recharged By</th>
                                 <th class="tdCenter">Transaction date</th>
                                 <th class="tdCenter">Description</th>
                                 <th class="tdCenter">Last Balance</th>
                                 <th class="tdCenter">TNX Type</th>
                                 <th class="tdCenter">PIN</th>
                                 <th class="tdCenter">Cash Amount</th>
                                 <th class="tdCenter">Row Total</th>
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="(data, index) in listArr" :key="data.id">
                                 <td :class="'tdCenter tdSN'">
                                    {{parseInt(++index)}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.reseller_name}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.recharged_by}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.creationdate}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.description}}
                                 </td>
                                 <td class="tdCenter">
                                    {{data.lastbalance}}
                                 </td>
                                 <td class="tdCenter">
                                    <span v-if="data.type==1">Received</span>
                                    <span v-else>Return</span>
                                 </td>
                                 <td class="tdCenter">
                                    {{data.no_of_pins}}
                                 </td>
                                 <td class="tdCenter success">
                                    {{data.amount}}
                                 </td>
                                 <td class="tdCenter info">
                                    {{data.totalamount}}
                                 </td>
                             </tr>
                              <tr v-if="listArr.length==0">
                                 <td colspan="11" class="tdCenter" style="padding: 30px 0;"><b>No Records  Found</b></td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>

                  <div class="table-responsive">
                     <table class="table table-middle-small table-bordered">
                        <thead>
                           <tr>
                              <th class="tdCenter" rowspan="2">Total</th>
                              <th class="tdCenter">Transaction</th>
                              <th class="tdCenter">Received</th>
                              <th class="tdCenter">Returned</th>
                              <th class="tdCenter">Amount</th>
                           </tr>
                           <tr>
                              <th class="">{{listArr.length}}</th>
                              <th class="success">{{lineSale}}</th>
                              <th class="warning">{{lineReturn}}</th>
                              <th class="info">{{lineTotalAmount}}</th>
                           </tr>
                        </thead>
                     </table>
                  </div>

               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
   import filterDropdownOptions from "@/components/common/filterDropdownOptions.vue";
   import axios from 'axios'
   export default {
      name: "FlexRechargeReport",
      components: {
         filterDropdownOptions,
      },
      data() {
         return {
            listArr : [],
            userData : {},
            lineTotalAmount : 0,
            starttime : '',
            stoptime : '',
            login : '',
            userlevel:'',
            type:'',
            lineSale:0,
            lineReturn:0,
            flexApiUrl : process.env.VUE_APP_APIFLEXURL,
            styleObject: {
               background:'#ffa196 !important',
            }
         }
      },
      created(){
         if(!this.com_isTVReseller(true, [393])){
            this.$router.push('dashboard');
         }

         //Get User Level from user store
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         var userData = JSON.parse(decodedString);
         this.userData = userData;
         this.userlevel = userData.user_level;
         // End

         this.filterWiseDateRangeSet();
         this.searchReportData();
      },
      methods: {

         searchReportData(){
            loader.show();
            var rootObject = this;
   
            const form = new FormData()
            form.append('fromDate', this.starttime)
            form.append('toDate', this.stoptime)
            form.append('login', this.login)
            form.append('type', this.type)
            form.append('short_filter', $("#short_filter").val());
            form.append('idReseller', this.userData.id_reseller)
            form.append('level', this.userData.user_level)
            
            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }
   
            axios.post('tv-recharge-report', form, config).then(function (response) {
               //console.log(response);
               rootObject.populateReportData(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },
   
         populateReportData(response){
            var rootObject = this;
            var lineTotalAmount = 0;
            var lineSale = 0;
            var lineReturn = 0;
            this.lineTotalAmount = 0;
            this.listArr = [];

            for (var prop in response.data.data) { 

               if(response.data.data[prop]['type']==1){
                  lineTotalAmount += parseFloat(response.data.data[prop]['amount']); 
                  lineSale += parseFloat(response.data.data[prop]['amount']); 
               }else{
                  lineTotalAmount -= parseFloat(response.data.data[prop]['amount']); 
                  lineReturn -= parseFloat(response.data.data[prop]['amount']); 
               }

               response.data.data[prop]['totalamount'] = lineTotalAmount;
               this.listArr.push(response.data.data[prop]);
                
            }
            this.lineTotalAmount = lineTotalAmount.toFixed(2);
            this.lineSale = lineSale.toFixed(2);
            this.lineReturn = lineReturn.toFixed(2);
            loader.hide();
         },
   
         filterWiseDateRangeSet()
         {
            $(".datePicker").removeAttr('readonly', 'readonly'); 
            if ($("#short_filter").val()) {
               this.starttime = '';
               this.stoptime = '';
               $(".datePicker").attr('readonly', 'readonly'); 
            }else{
               var dateRangeArr = this.com_currentDateRange();
               this.starttime = dateRangeArr.startDate;
               this.stoptime = dateRangeArr.endDate;
            }
         },

         getFormattedTime() {
            var today = new Date();
            var y = today.getFullYear();
            var m = today.getMonth() + 1;
            var d = today.getDate();
            return y + "-" + m + "-" + d;
         },
         
      },
      mounted: function() {
         var rootObject = this;
         $('#starttime').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.starttime = $(this).val();
         });

         $('#stoptime').datetimepicker({
            timepicker: false,
            format: 'Y-m-d'
         }).on('change', function(e){
            rootObject.stoptime = $(this).val();
         });

         $("#short_filter").on('change', function(){
            rootObject.filterWiseDateRangeSet();
            rootObject.searchReportData();
         });
   
         $(".select2").select2();
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>